import { useMemo } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { collection, query, where } from 'firebase/firestore';
import { db } from '@/lib/firebase/config';
import { COLLECTIONS, splitPath } from '@elka/firebase';
import { useAuth } from '../../auth/hooks/useAuth';
import { toTicket } from '../tickets';

/** My open tickets (assigned to me, not done) from the tasks app. */
export function useMyTickets() {
  const { user } = useAuth();
  const uid = user?.uid;

  // Done tickets are filtered on the client: a `!=` would need its own index and order.
  const ticketsQuery = useMemo(
    () =>
      uid
        ? query(
            collection(db, ...splitPath(COLLECTIONS.tasks.tickets)),
            where('assigneeId', '==', uid)
          )
        : null,
    [uid]
  );

  const [snapshot, loading, error] = useCollection(ticketsQuery);

  const tickets = useMemo(
    () => snapshot?.docs.map(toTicket).filter((t) => t.status !== 'done') ?? [],
    [snapshot]
  );

  return { tickets, isLoading: loading, error: error?.message || null };
}
